// helpers/clearAllCaches.ts

import { useAnalyticsContentCacheStore } from 'store/analyticsContentCacheStore'
import { useMessagesAnalyticsCacheStore } from 'store/analyticsContentMessageStore'
import { useAnalyticsReportsCacheStore } from 'store/analyticsReportsCache'
import { useAnalyticsSalesCacheStore } from 'store/analyticsSalesCacheStore'
import { useBrowseCreatorsCacheStore } from 'store/browseCreatorsCacheStore'
import { useCommentsCacheStore } from 'store/commentsCacheStore' // NEW
import { useConversationCacheStore } from 'store/conversationCacheStore' // NEW
import { useDiscoverFeedCacheStore } from 'store/discoverFeedCacheStore' // NEW
import { useFanDetailsCacheStore } from 'store/fanDetailsCacheStore'
import { useFanGroupsCacheStore } from 'store/fanGroupsCacheStore'
import { useFollowingFeedCacheStore } from 'store/followingFeedCacheStore'
import { useInboxCacheStore } from 'store/inboxCacheStore'
import { useLikesHistoryFirstPageCacheStore } from 'store/likesHistoryFirstPageCacheStore' // NEW
import { useMediaCacheStore } from 'store/mediaCacheStore'
import { useMediaCategoryStore } from 'store/mediaCategoryStore'
import { useNewPostSharedMediaCacheStore } from 'store/newPostSharedMediaCacheStore'
import { useNotificationStore } from 'store/notificationsCacheStore'
import { useNotificationSettingsStore } from 'store/notificationSettingsCacheStore' // NEW
import { usePayoutsCacheStore } from 'store/payoutsCacheStore' // NEW
import { usePreviewStore } from 'store/previewStore'
import { useProfileCacheStore } from 'store/profileCacheStore'
import { useProfileFeedCacheStore } from 'store/profileFeedCacheStore'
import { usePurchasesCacheStore } from 'store/purchasesCacheStore' // NEW
import { useReferralsGraphCacheStore } from 'store/referralsGraphCacheStore' // NEW
import { useSalesCacheStore } from 'store/salesCacheStore'
import { useSubscriptionCacheStore } from 'store/subscriptionCacheStore'
import { useSubscriptionListsCacheStore } from 'store/subscriptionListsCacheStore'
import { useTransactionCacheStore } from 'store/transactionCacheStore'
import { useVaultCacheStore } from 'store/vaultCacheStore'
import { useVaultChatCacheStore } from 'store/vaultChatCacheStore'

// Model-only cache stores
export function clearModelCaches() {
  useAnalyticsContentCacheStore.getState().clear()
  useMessagesAnalyticsCacheStore.getState().clear()
  useAnalyticsReportsCacheStore.getState().clear()
  useAnalyticsSalesCacheStore.getState().clear()
  useFanDetailsCacheStore.getState().clear()
  useFanGroupsCacheStore.getState().clear()
  useMediaCategoryStore.getState().clear()
  useNewPostSharedMediaCacheStore.getState().clear()
  usePayoutsCacheStore.getState().clearAll()
  useReferralsGraphCacheStore.getState().clearAll()
  useVaultCacheStore.getState().clear()
  useVaultChatCacheStore.getState().clear()
}

// Shared caches (fans + models)
export function clearSharedCaches() {
  useBrowseCreatorsCacheStore.getState().clear()
  useCommentsCacheStore.getState().clear()
  useConversationCacheStore.getState().clear()
  useDiscoverFeedCacheStore.getState().clear()
  useFollowingFeedCacheStore.getState().clear()
  useInboxCacheStore.getState().clear()
  useLikesHistoryFirstPageCacheStore.getState().clear()
  useMediaCacheStore.getState().clear()
  useNotificationStore.getState().clear()
  useNotificationSettingsStore.getState().clearSettings()
  usePreviewStore.getState().resetPreviewState()
  useProfileCacheStore.getState().clear()
  useProfileFeedCacheStore.getState().clear()
  usePurchasesCacheStore.getState().clearAll()
  useSalesCacheStore.getState().clear()
  useSubscriptionCacheStore.getState().clear()
  useSubscriptionListsCacheStore.getState().clear()
  useTransactionCacheStore.getState().clear()
}
// All caches for a model (full wipe)
export function clearAllCachesForModel() {
  clearModelCaches()
  clearSharedCaches()
}

// Only shared caches (fans)
export function clearAllCachesForFan() {
  clearSharedCaches()
}

// If you want a single "nuke" function (not role-safe, not recommended unless you never mix roles):
export function clearAllCaches() {
  clearModelCaches()
  clearSharedCaches()
}
